var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.message,
    placement: 'top-center',
    classes: ['my-tooltip']
  }),expression:"{\n    content: message,\n    placement: 'top-center',\n    classes: ['my-tooltip']\n  }"}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }